import React from 'react';
import styles from '../styles.module.css';
import AppLink from '@/components/common/AppLink';
import { InfoCardItem } from '@/commonTypes';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';

export default function InfoCard({
  item,
  statValueClass = '',
  className = '',
}: {
  item?: InfoCardItem;
  statValueClass?: string;
  className?: string;
}) {
  const Tag = item?.href ? AppLink : 'div';
  return (
    <Tag className={`${styles.statTile} ${className}`} href={item?.href}>
      <div className={styles.statLabel}>{item?.title}</div>
      {/* <div className={`${styles.statValue} ${statValueClass}`}>
        {item?.text}
        {item?.unit && <span className={styles.statUnit}>{item?.unit}</span>}
      </div> */}
      <PriceSection
        value={item?.text}
        className={`${styles.statValue} ${statValueClass}`}
        unit={item?.unit}
      />
    </Tag>
  );
}
